/**
 * Moduł obsługujący zmianę i usunięcie metody płatności dla subskrypcji.
 */
app.service('subscriptionPaymentMethod', function (loading, modal, subscriptionResignForm, ajaxErrorHandler) {

	let subscriptionRecurringPaymentId;
	let subscriptionPaymentMethodType;
	let subscriptionPaymentTokenId;
	let onRemoveCompleteCallback;

	/**
	 * Zmiana metody płatności (karty/BLIK) dla subskrypcji.
	 * @param {string} recurringPaymentId - identyfikator płatności cyklicznej
	 * @param {string} paymentMethod - typ metody płatności (np. CARD, BLIK_RECURRING)
	 */
	function changePaymentToken(recurringPaymentId, paymentMethod) {
		loading.start();
		$.ajax({
			url: '/customer-subscription-payment-change-token.ltr',
			type: 'POST',
			data: {
				recurringPaymentId,
				paymentMethod
			},
			success: function (result) {
				if (result.status === 'SUCCESS') {
					loading.redirect(result.transactionPaymentUrl);
				} else {
					modal.alert(result.messages);
				}
			},
			error: ajaxErrorHandler.createFailHandler('subscriptionPaymentMethod.changePaymentToken'),
			complete() {
				loading.stop();
			}
		});
	}

	/**
	 * Usunięcie metody płatności
	 * @param {string} recurringPaymentId - identyfikator płatności cyklicznej
	 * @param {string} paymentMethod - typ metody płatności (np. CARD, BLIK_RECURRING)
	 * @param {string} paymentTokenId - identyfikator tokena metody płatności
	 * @param {function(Object)} onComplete - callback wywoływany po zakończeniu operacji
	 */
	function removePaymentMethod(recurringPaymentId, paymentMethod, paymentTokenId, onComplete) {
		subscriptionRecurringPaymentId = recurringPaymentId;
		subscriptionPaymentMethodType = paymentMethod;
		subscriptionPaymentTokenId = paymentTokenId;
		onRemoveCompleteCallback = onComplete;

		loadRemovePaymentMethodResignForm();
	}

	/**
	 * Doczytuje formularz z ankietą, który pozwala użytkownikowi podać powód usunięcia metody płatności
	 */
	function loadRemovePaymentMethodResignForm() {
		loading.start();

		$.ajax({
			url: '/customer-subscription-payment-method-remove-reason.ltr',
			type: 'GET',
			success(questionnaireHtml) {
				openModal(questionnaireHtml);
			},
			error: ajaxErrorHandler.createFailHandler('subscriptionPaymentMethod.loadRemovePaymentMethodResignForm'),
			complete() {
				loading.stop();
			}
		});
	}

	function openModal(questionnaireHtml) {

		modal.generate({
			id: 'payment-method-resign-modal',
			content: questionnaireHtml,
			buttons: [
				{
					text: "Usuń mimo to",
					cssClass: 'confirm-resignation is-disabled',
					click: confirmRemovePaymentMethod
				},
				{
					text: "Zachowaj metodę",
					cssClass: 'cancel-resignation',
					click: function () {
						modal.close();
					}
				}
			]
		});
	}

	/**
	 * Obsługa wysyłki ankiety po kliknięciu "Potwierdzam usunięcie"
	 */
	function confirmRemovePaymentMethod() {
		loading.start();

		const {closeReasonName, closeReasonDescription} = subscriptionResignForm.getResignFormData();

		$.ajax({
			url: '/customer-subscription-payment-method-remove.ltr',
			type: 'POST',
			contentType: 'application/json',
			data: JSON.stringify({
				recurringPaymentId: subscriptionRecurringPaymentId,
				paymentMethod: subscriptionPaymentMethodType,
				closeReasonName,
				closeReasonDescription
			}),
			success(result) {
				if (typeof onRemoveCompleteCallback === 'function') {
					onRemoveCompleteCallback(result);
				}
				modal.close();
			},
			error: ajaxErrorHandler.createFailHandler('subscriptionPaymentMethod.confirmRemovePaymentMethod'),
			complete() {
				loading.stop();
			}
		});
	}

	return {
		changePaymentToken,
		removePaymentMethod
	};
});
